export default __webpack_public_path__ + "static/media/practice.8774a846.svg";